import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';

@Injectable({
  providedIn: 'root'
})
export class RequirementReviewService extends BaseProvider {
	requirementType: any;
	requirementReviewFormIsVisible: any = false;
	requirementId: any;
	requirement: any;
  	constructor(
		public globals: GlobalsService,
 		public http: HttpClient,	
 		public ls: LsHelperService,
  	) { 
		super();

		this.baseUrl = "userProcessRequirement";
	}

	markForRevision(userProcessId, processId, flag, data){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 
					   this.baseUrl + `/process/${this.requirementId}/type/${this.requirementType}/verificationFlag/${flag}/userProcessId/${userProcessId}`;

	        this.http
	        .post(
	          this.url, 
	          data
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    }); 		
	}	

	unMarkForRevision(processId, hasForm){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 
					   this.baseUrl + `/cancel/process/${processId}` + 
					   				  `/requirementId/${this.requirementId}` +
					   				  `/hasForm/${hasForm}`;

	        this.http
	        .post(
	          this.url, 
	          null
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    }); 		
	}
	
	getComments(){
		return new Promise ((resolve, reject) => {
			this.url = this.globals.dataUrl + 'lookup/requirement/comment/templates';

			this.http.get(this.url)
			.subscribe( 
				(data: any) => { resolve(data) },
				(err: any) => { reject( err ) }
			);
		})
	}
}
